import { Button, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { useState } from 'react';
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { RiEyeLine, RiEyeOffFill } from 'react-icons/ri';

import { FormField } from './form-field';

type FormPasswordInputProps = {
  disabled?: boolean;
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  placeholder: string;
  register: ReturnType<UseFormRegister<any>>;
  variant?: object;
  doTrim?: boolean;
  setValue?: UseFormSetValue<any>;
};

export const FormPasswordInput = (props: FormPasswordInputProps) => {
  console.info('form-password-input.tsx_1');

  const {
    disabled = false,
    error,
    register,
    placeholder,
    variant,
    doTrim,
    setValue,
  } = props;
  const [show, setShow] = useState(false);

  return (
    <FormField error={error}>
      <InputGroup>
        <Input
          disabled={disabled}
          {...register}
          type={show ? 'text' : 'password'}
          placeholder={placeholder}
          {...variant}
          onChange={(e) => {
            console.info('form-password-input.tsx_2');

            if (doTrim && setValue) {
              console.info('form-password-input.tsx_3');

              setValue!(e.target.name, e.target.value.trim());
            }
          }}
        />
        <InputRightElement>
          <Button size="sm" h="100%" onClick={() => setShow(!show)}>
            {show ? <RiEyeOffFill /> : <RiEyeLine />}
          </Button>
        </InputRightElement>
      </InputGroup>
    </FormField>
  );
};
